export default {
  name: 'changde',
  adcode: '430700',
  mapName: '常德市',
  geoJsonPath: 'hunanmap/430700.json',
  backgroundImage: {
    png: '常德市_430700.png',
    webp: '常德市_430700.webp'
  },
  echartsMapStyle: {
    width: '692px',
    height: '725px',
    marginTop: 'auto',
    marginBottom: '39px',
  },
  imageSize: {
    width: 3194,
    height: 3346
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 0.99, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 0.99, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.004,  // X轴偏移百分比
      y: 0.008  // Y轴偏移百分比
    }
  },
  // 区县列表
  districts: ['常德市区', '安乡县', '汉寿县', '澧县', '临澧县', '桃源县', '石门县', '津市市'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（用于兜底展示）
    '常德市区': [111.690718, 29.040477],
    '常德市': [111.690718, 29.050477],
    // 县与县级市坐标（来自 430700.json center）
    '安乡县': [112.068289, 29.436483],
    '汉寿县': [111.958506, 28.881319],
    '澧县': [111.751682, 29.78364],
    '临澧县': [111.585602, 29.423217],
    '桃源县': [111.144503, 28.912734],
    '石门县': [111.046087, 29.804703],
    '津市市': [111.899609, 29.472867],
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    // 城区归并到“常德市区”
    if (s === '常德市') return '常德市区'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '武陵区': '430702',
    '鼎城区': '430703',
    '安乡县': '430721',
    '汉寿县': '430722',
    '澧县': '430723',
    '临澧县': '430724',
    '桃源县': '430725',
    '石门县': '430726',
    '津市市': '430781'
  }
}